import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, Phone, MapPin } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { usePublicSettings } from "@/context/SettingsContext";
import logoLight from "@/assets/logo-light.png";

export const Footer = () => {
  const { t } = useLang();
  const s = usePublicSettings();

  return (
    <footer data-testid="footer" className="bg-petrol text-[#FDFBF7]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-24 pb-12">
        <div className="border-b border-white/10 pb-16 mb-12">
          <img src={logoLight} alt="Fiorucci Apartments — Case Vacanze" className="h-28 md:h-32 w-auto mb-8" />
          <h2 className="font-serif font-light text-[12vw] md:text-[7vw] leading-[0.9] tracking-tight">
            {t("footer.tagline")}
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <div>
            <p className="overline text-white/50 mb-5">{t("footer.explore")}</p>
            <ul className="space-y-3 text-sm">
              <li><Link to="/apartments" className="link-underline text-white/85 hover:text-white">{t("nav.apartments")}</Link></li>
              <li><Link to="/faq" className="link-underline text-white/85 hover:text-white">{t("nav.faq")}</Link></li>
              <li><Link to="/guide" className="link-underline text-white/85 hover:text-white">{t("nav.guide")}</Link></li>
              <li><Link to="/contact" className="link-underline text-white/85 hover:text-white">{t("nav.contact")}</Link></li>
            </ul>
          </div>
          <div>
            <p className="overline text-white/50 mb-5">{t("footer.legal")}</p>
            <ul className="space-y-3 text-sm">
              <li><Link to="/privacy" className="link-underline text-white/85 hover:text-white">{t("footer.privacy")}</Link></li>
              <li><Link to="/cookie-policy" className="link-underline text-white/85 hover:text-white">{t("footer.cookie")}</Link></li>
              <li><Link to="/admin" className="link-underline text-white/85 hover:text-white">{t("nav.admin")}</Link></li>
            </ul>
          </div>
          <div>
            <p className="overline text-white/50 mb-5">{t("contact.title")}</p>
            <ul className="space-y-3 text-sm text-white/85">
              {s.contact_email && <li className="flex items-center gap-2"><Mail size={14} strokeWidth={1.5} /> {s.contact_email}</li>}
              {s.contact_phone && <li className="flex items-center gap-2"><Phone size={14} strokeWidth={1.5} /> {s.contact_phone}</li>}
              {s.address && <li className="flex items-center gap-2"><MapPin size={14} strokeWidth={1.5} /> {s.address}</li>}
            </ul>
          </div>
          <div>
            <p className="overline text-white/50 mb-5">{t("footer.follow")}</p>
            <div className="flex gap-4">
              {s.social_instagram && (
                <a href={s.social_instagram} target="_blank" rel="noreferrer" className="text-white/85 hover:text-gold transition-colors">
                  <Instagram size={20} strokeWidth={1.5} />
                </a>
              )}
              {s.social_facebook && (
                <a href={s.social_facebook} target="_blank" rel="noreferrer" className="text-white/85 hover:text-gold transition-colors">
                  <Facebook size={20} strokeWidth={1.5} />
                </a>
              )}
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/50">
          <span>© {new Date().getFullYear()} {s.brand_name || "Fiorucci Apartments"}. {t("footer.rights")}</span>
          <span>{t("footer.tagline")}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
